import(/* webpackMode: "eager" */ "/codebuild/output/src1053796749/src/doctor-dashboard/src/components/loader/AppLoader.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1053796749/src/doctor-dashboard/src/components/loader/SplashScreenLoader.tsx");
